export default "__VITE_ASSET__262cefc6__"